import { Droplets, Thermometer, Battery, Camera, MapPin, Brain, LucideIcon } from "lucide-react";

interface Benefit {
  icon: LucideIcon;
  title: string;
  desc: string;
}

const soloBenefits: Benefit[] = [
  {
    icon: Droplets,
    title: "Économisez jusqu'à 60% d'eau",
    desc: "Arrosez uniquement quand c'est nécessaire. CynthIA mesure l'humidité exacte à la racine.",
  },
  {
    icon: Thermometer,
    title: "Surveille tout ton massif ou ton carré de potager",
    desc: "Analyse la température et l'humidité du sol et de l'air en continu.",
  },
  {
    icon: Battery,
    title: "Installez et oubliez",
    desc: "200 jours d'autonomie. Étanche IP67. Installation en 2 minutes.",
  },
  {
    icon: Camera,
    title: "Docteur 100% Naturel",
    desc: "Prenez en photo une feuille jaune. L'appli croise l'image avec les données du sol pour un remède naturel.",
  },
];

const duoBenefits: Benefit[] = [
  {
    icon: MapPin,
    title: "Gestion Multi-Zones",
    desc: "Intérieur vs extérieur, potager vs massif… Gérez vos deux zones depuis une seule application.",
  },
  {
    icon: Brain,
    title: "Double protection Expert",
    desc: "Votre expert horticole croise les données de vos deux zones simultanément pour des conseils ultra-précis.",
  },
  {
    icon: Droplets,
    title: "Économie maximale",
    desc: "Plus de 19€ d'économie par rapport à deux packs Solo. Doublez la couverture, pas le prix.",
  },
  {
    icon: Battery,
    title: "+200 jours d'autonomie par boîtier",
    desc: "Piles fournies pour les deux boîtiers. Étanches IP67. Installation en 2 minutes chacun.",
  },
];

interface BenefitsGridProps {
  productId?: string;
}

export const BenefitsGrid = ({ productId }: BenefitsGridProps) => {
  const benefits = productId === "pack-duo" ? duoBenefits : soloBenefits;

  return (
    <section className="py-12 md:py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-foreground mb-10">
          Tout ce dont votre jardin a besoin. <span className="text-primary">CynthIA !</span>
        </h2>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-6">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="flex gap-4 p-5 rounded-2xl bg-card border border-border/50 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <b.icon className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h3 className="font-bold text-foreground text-sm md:text-base mb-1">{b.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
